import {
  Card,
  Paper,
  Title,
  Text,
  Group
} from "@mantine/core";
import { Link } from "react-router-dom";
import {
  IconCalendar,
  IconDeviceDesktop,
  IconIcons,
  IconId,
  IconSocial,
  IconSpeakerphone
} from "@tabler/icons-react";

export default function SelectNewRequestType() {
  return (
    <Paper p={18} radius={0} mih="100vh">
      <Title order={1}>New request</Title>
      <Text my={16}>Select request type</Text>

      <Card
        withBorder={true}
        component={Link}
        to="/design_projects/new"
        my={12}
      >
        <Group gap="xs">
          <IconIcons />
          <Title order={2}>Design Project</Title>
        </Group>
        <Text>
          Request a print design project, such as a poster, flyer, or brochure.
        </Text>
      </Card>

      <Card
        withBorder={true}
        component={Link}
        to="/web_updates/new"
        my={12}
      >
        <Group gap="xs">
          <IconDeviceDesktop />
          <Title order={2}>Web Update</Title>
        </Group>
        <Text>
          Update existing web pages.
        </Text>
      </Card>

      <Card
        withBorder={true}
        component={Link}
        to="/events/new"
        my={12}
      >
        <Group gap="xs">
          <IconCalendar />
          <Title order={2}>Event/Campus News</Title>
        </Group>
        <Text>
          Promote an event or share campus news.
        </Text>
      </Card>

      <Card
        withBorder={true}
        component={Link}
        to="/social_media_posts/new"
        my={12}
      >
        <Group gap="xs">
          <IconSocial />
          <Title order={2}>Social Media Post</Title>
        </Group>
        <Text>
          Request a social media post to be created and/or published.
        </Text>
      </Card>

      <Card
        withBorder={true}
        component={Link}
        to="/marketing_campaigns/new"
        my={12}
      >
        <Group gap="xs">
          <IconSpeakerphone />
          <Title order={2}>Marketing Project</Title>
        </Group>
        <Text>
          Initiate a paid marketing campaign, major design project, or major
          web project.
        </Text>
      </Card>

      <Card
        withBorder={true}
        component={Link}
        to="/business_cards/new"
      >
        <Group gap="xs">
          <IconId />
          <Title order={2}>Business Card</Title>
        </Group>
        <Text>
          Request business cards.
        </Text>
      </Card>

    </Paper>
  )
}
